var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBoleto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 23.4 24.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666b70;stroke-width:0}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.796 17.913H1.027V6.298h4.77v11.615Zm-3.421-1.348h2.074v-8.92H2.375v8.92ZM16.841 17.913h-4.044V6.298h4.044v11.615Zm-2.696-1.348h1.348v-8.92h-1.348v8.92ZM7.35 6.298h1.348v11.615H7.35V6.298ZM10.154 6.298H11.5v11.615h-1.347V6.298ZM18.279 6.298h1.347v11.615H18.28V6.298ZM20.93 6.298h1.347v11.615H20.93V6.298ZM1.551 4.637H.204V1.47h3.219v1.348H1.55v1.82ZM23.196 4.637H21.85v-1.82h-1.872V1.47h3.22v3.167ZM3.423 22.63H.203v-3.167h1.348v1.82h1.872v1.347ZM23.196 22.63h-3.219v-1.348h1.872v-1.82h1.347v3.168Z",
    className: "cls-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBoleto);
export default __webpack_public_path__ + "static/media/DownloadBoleto.556c03e7946ca2947c7c7a9cbbc39430.svg";
export { ForwardRef as ReactComponent };